import { Box, Paper, Typography } from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";
import { Button, Callout, PageHeader } from "@components/ui_v2";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { PATHS_EXPEDIENTE_V2, STATUS_CATALOG, TAX_SYSTEM_TYPE } from "@helpers/constantes";
import useLoanStatusPolling from "@hooks/useLoanStatusPolling";

export const ErroresExpediente = () => {
  const navigate = useNavigate();

  const application = useSelector((state: RootState) => state.register.application);
  const taxSystemType = application.tax_system_type;

  const isPF = taxSystemType === TAX_SYSTEM_TYPE.PF.code;
  const isPFAE = taxSystemType === TAX_SYSTEM_TYPE.PFAE.code;
  const isPM = !isPF && !isPFAE;

  const errorStatusCode = isPF
    ? STATUS_CATALOG.errores_expediente_pf.code
    : isPFAE
      ? STATUS_CATALOG.errores_expediente_pfae.code
      : STATUS_CATALOG.errores_expediente_pm.code;

  useLoanStatusPolling(errorStatusCode, "ErroresExpediente");

  const expedienteUrl = isPF
    ? "/producto/creditosimple/expediente_pf"
    : isPFAE
      ? PATHS_EXPEDIENTE_V2.pfaeExpediente.path
      : PATHS_EXPEDIENTE_V2.expediente.path;

  const subtitle = isPM
    ? "Ve a la sección o secciones marcadas con faltantes para resolverlos."
    : "Podría ser necesario editar algunas secciones o volver a cargar algunos documentos.";

  const buttonLabel = isPM ? "Revisar expediente" : "Volver a llenar";

  return (
    <Box>
      <PageHeader eyebrow="Expediente" title="Faltantes en tu expediente" subtitle={subtitle} />

      <Paper variant="lendia_paper" sx={{ mt: 2, px: 4 }}>
        <Typography variant="body2" color="tokens.textSecondary" sx={{ lineHeight: 1.55 }}>
          Encontramos faltantes dentro de la validación de tu expediente. Revisa las secciones indicadas y completa o
          corrige la información antes de continuar.
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Callout tone="warn" icon={<WarningAmberOutlined sx={{ fontSize: 18 }} />}>
            Podría ser necesario editar algunas secciones o volver a cargar algunos documentos.
          </Callout>
        </Box>
      </Paper>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Button onClick={() => navigate(expedienteUrl)} data-testid="errores-expediente-revisar-button">{buttonLabel}</Button>
      </Box>
    </Box>
  );
};
